const map = {
	"./ak2/logo.svg": 38839,
	"./amico-logo.svg": 8476,
	"./br2/logo.svg": 73607,
	"./bubble-logo.svg": 14463,
	"./cbat.svg": 17883,
	"./cchat.svg": 23360,
	"./ccon-doi-kaka.svg": 26650,
	"./cflygram-kaka.svg": 69733,
	"./cflygram.svg": 98240,
	"./cmail-kaka.svg": 40752,
	"./cmail.svg": 70359,
	"./cmeetalk.svg": 11115,
	"./cpaopao.svg": 54978,
	"./cqq-kaka.svg": 92041,
	"./cqq.svg": 21188,
	"./cskype-kaka.svg": 68997,
	"./cskype.svg": 55424,
	"./cteams.svg": 86988,
	"./ctelegram.svg": 90923,
	"./czalo.svg": 24422,
	"./empty.svg": 13662,
	"./home/bonus.svg": 26590,
	"./home/money.svg": 93423,
	"./home/moneybal.svg": 79568,
	"./home/netprofit.svg": 296,
	"./home/payment.svg": 62569,
	"./home/profit.svg": 28135,
	"./home/rebate.svg": 86932,
	"./imgicon.svg": 29547,
	"./kaka/cs-24-kaka.svg": 93420,
	"./kr/kr-logo.svg": 16292,
	"./login/first-liner.svg": 73614,
	"./login/second-liner.svg": 19234,
	"./mx4/logo.svg": 58054,
	"./personal-center.svg": 68279,
	"./vi/vilogo.svg": 59105
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36599;